import { Fragment, type ReactElement } from "react";

const steps = [
  { label: "Add creative", color: "pink" },
  { label: "Customize", color: "purple" },
  { label: "Render", color: "blue" },
] as const;

/** Reusable visual overview of the MotionTwist creation process. */
export function ProcessOverview(): ReactElement {
  return <section className="process-overview" aria-label="Video creation process">
    <ol>
      {steps.map((step, index) => <Fragment key={step.label}>
        <li className={`is-${step.color}`}>
          <b>{index + 1}</b><span>{step.label}</span>
        </li>
        {index < steps.length - 1 && <i className={`process-overview-connector is-${step.color}`} aria-hidden="true" />}
      </Fragment>)}
    </ol>
  </section>;
}
